import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1
};
import { getBoolDictOptions, DICT_TYPE } from '@/utils/dict';
import { ChatRoleApi } from '@/api/ai/model/chatRole';
import ChatRoleForm from './ChatRoleForm.vue';
import { onMounted, reactive, ref } from 'vue';
import { useMessage } from '@/hooks/web/useMessage';
import Icon from '@/components/Icon/src/Icon.vue';
/** AI 聊天角色 列表 */
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'AiChatRole'
  },
  __name: 'index',
  setup(__props) {
    const message = useMessage(); // 消息弹窗
    // const { t } = useI18n() // 国际化
    const loading = ref(true); // 列表的加载中
    const list = ref([]); // 列表的数据
    const total = ref(0); // 列表的总页数
    const queryParams = reactive({
      pageNo: 1,
      pageSize: 10,
      name: undefined,
      category: undefined,
      publicStatus: true
    });
    const queryFormRef = ref(); // 搜索的表单
    /** 查询列表 */
    const getList = async () => {
      loading.value = true;
      try {
        const data = await ChatRoleApi.getChatRolePage(queryParams);
        list.value = data.list;
        total.value = data.total;
      } finally {
        loading.value = false;
      }
    };
    /** 搜索按钮操作 */
    const handleQuery = () => {
      queryParams.pageNo = 1;
      getList();
    };
    /** 重置按钮操作 */
    const resetQuery = () => {
      queryFormRef.value.resetFields();
      handleQuery();
    };
    /** 添加/修改操作 */
    const formRef = ref();
    const openForm = (type, id) => {
      formRef.value.open(type, id);
    };
    /** 删除按钮操作 */
    const handleDelete = async id => {
      try {
        // 删除的二次确认
        await message.delConfirm();
        // 发起删除
        await ChatRoleApi.deleteChatRole(id);
        message.success('删除成功');
        // 刷新列表
        await getList();
      } catch {}
    };
    /** 初始化 **/
    onMounted(() => {
      getList();
    });
    return (_ctx, _cache) => {
      const _component_doc_alert = _resolveComponent("doc-alert");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_ContentWrap = _resolveComponent("ContentWrap");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_image = _resolveComponent("el-image");
      const _component_dict_tag = _resolveComponent("dict-tag");
      const _component_el_table = _resolveComponent("el-table");
      const _component_Pagination = _resolveComponent("Pagination");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_doc_alert, {
        title: "AI 对话聊天",
        url: "https://doc.iocoder.cn/ai/chat/"
      }), _createVNode(_component_ContentWrap, null, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          class: "-mb-15px",
          model: queryParams,
          ref_key: "queryFormRef",
          ref: queryFormRef,
          inline: true,
          "label-width": "68px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "角色名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: queryParams.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => queryParams.name = $event),
              placeholder: "请输入角色名称",
              clearable: "",
              onKeyup: _withKeys(handleQuery, ["enter"]),
              class: "!w-240px"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "角色类别",
            prop: "category"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: queryParams.category,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => queryParams.category = $event),
              placeholder: "请输入角色类别",
              clearable: "",
              onKeyup: _withKeys(handleQuery, ["enter"]),
              class: "!w-240px"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "是否公开",
            prop: "publicStatus"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: queryParams.publicStatus,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => queryParams.publicStatus = $event),
              placeholder: "请选择是否公开",
              clearable: "",
              class: "!w-240px"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getBoolDictOptions)(_unref(DICT_TYPE).INFRA_BOOLEAN_STRING), dict => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: dict.value,
                  label: dict.label,
                  value: dict.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              onClick: handleQuery
            }, {
              default: _withCtx(() => [_createVNode(Icon, {
                icon: "ep:search",
                class: "mr-5px"
              }), _cache[6] || (_cache[6] = _createTextVNode(" 搜索"))]),
              _: 1
            }), _createVNode(_component_el_button, {
              onClick: resetQuery
            }, {
              default: _withCtx(() => [_createVNode(Icon, {
                icon: "ep:refresh",
                class: "mr-5px"
              }), _cache[7] || (_cache[7] = _createTextVNode(" 重置"))]),
              _: 1
            }), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "primary",
              plain: "",
              onClick: _cache[3] || (_cache[3] = $event => openForm('create'))
            }, {
              default: _withCtx(() => [_createVNode(Icon, {
                icon: "ep:plus",
                class: "mr-5px"
              }), _cache[8] || (_cache[8] = _createTextVNode(" 新增 "))]),
              _: 1
            })), [[_directive_hasPermi, ['ai:chat-role:create']]])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }), _createVNode(_component_ContentWrap, null, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: list.value,
          stripe: true,
          "show-overflow-tooltip": true
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "角色名称",
            align: "center",
            prop: "name"
          }), _createVNode(_component_el_table_column, {
            label: "绑定模型",
            align: "center",
            prop: "modelName"
          }), _createVNode(_component_el_table_column, {
            label: "角色头像",
            align: "center",
            prop: "avatar"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_image, {
              src: scope?.row.avatar,
              class: "w-32px h-32px"
            }, null, 8, ["src"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "角色类别",
            align: "center",
            prop: "category"
          }), _createVNode(_component_el_table_column, {
            label: "角色描述",
            align: "center",
            prop: "description"
          }), _createVNode(_component_el_table_column, {
            label: "角色设定",
            align: "center",
            prop: "systemMessage"
          }), _createVNode(_component_el_table_column, {
            label: "知识库",
            align: "center",
            prop: "knowledgeIds"
          }, {
            default: _withCtx(scope => [!scope.row.knowledgeIds || scope.row.knowledgeIds.length === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_1, "-")) : (_openBlock(), _createElementBlock("span", _hoisted_2, "引用 " + _toDisplayString(scope.row.knowledgeIds.length) + " 个", 1))]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "工具",
            align: "center",
            prop: "toolIds"
          }, {
            default: _withCtx(scope => [!scope.row.toolIds || scope.row.toolIds.length === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_3, "-")) : (_openBlock(), _createElementBlock("span", _hoisted_4, "引用 " + _toDisplayString(scope.row.toolIds.length) + " 个", 1))]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "是否公开",
            align: "center",
            prop: "publicStatus"
          }, {
            default: _withCtx(scope => [_createVNode(_component_dict_tag, {
              type: _unref(DICT_TYPE).INFRA_BOOLEAN_STRING,
              value: scope.row.publicStatus
            }, null, 8, ["type", "value"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "状态",
            align: "center",
            prop: "status"
          }, {
            default: _withCtx(scope => [_createVNode(_component_dict_tag, {
              type: _unref(DICT_TYPE).COMMON_STATUS,
              value: scope.row.status
            }, null, 8, ["type", "value"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "角色排序",
            align: "center",
            prop: "sort"
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            align: "center"
          }, {
            default: _withCtx(scope => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
              link: "",
              type: "primary",
              onClick: $event => openForm('update', scope.row.id)
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode(" 编辑 ")])),
              _: 2
            }, 1032, ["onClick"])), [[_directive_hasPermi, ['ai:chat-role:update']]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              link: "",
              type: "danger",
              onClick: $event => handleDelete(scope.row.id)
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode(" 删除 ")])),
              _: 2
            }, 1032, ["onClick"])), [[_directive_hasPermi, ['ai:chat-role:delete']]])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), _createVNode(_component_Pagination, {
          total: total.value,
          page: queryParams.pageNo,
          "onUpdate:page": _cache[4] || (_cache[4] = $event => queryParams.pageNo = $event),
          limit: queryParams.pageSize,
          "onUpdate:limit": _cache[5] || (_cache[5] = $event => queryParams.pageSize = $event),
          onPagination: getList
        }, null, 8, ["total", "page", "limit"])]),
        _: 1
      }), _createVNode(ChatRoleForm, {
        ref_key: "formRef",
        ref: formRef,
        onSuccess: getList
      }, null, 512)], 64);
    };
  }
});